import React from 'react';
import { Steps as AntSteps, StepProps } from 'antd';
import { StepsProps } from 'antd/lib/steps';

// Definindo um tipo que inclui a propriedade 'Step'
interface StepsComponent extends React.FC<StepsProps> {
  Step: React.FC<StepProps>;
}

// Definindo o componente Steps
const Steps: StepsComponent = (props) => <AntSteps {...props} />;

// Reexportando o Step
Steps.Step = AntSteps.Step;

export default Steps;
